<template>
  <div>
    <advanced-table
      :headers="headers"
      :filters="filters"
      :sortBy="['created']"
      :sortDesc="[false]"
      :resource="resource"
      :optionLists="optionLists"
    />
  </div>
</template>

<script>
import AdvancedTable from "@/components/AdvancedTable.vue";
import mixins from "@/mixins/mixins";

export default {
  data() {
    return {
      clickedImei: null,
      headers: [
        {
          text: "מזהה חשבונית",
          value: "invoiceId",
          align: "start",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            return data[key] ? data[key] : "ללא מזהה";
          }
        },
        {
          text: "האם נשלחה?",
          value: "sentByEmail",
          align: "start",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            return data[key] ? "כן" : "לא";
          }
        },
        {
          text: "הזמנה",
          value: "order",
          align: "start",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            return data[key] ? data[key] : "ללא מזהה";
          },
          linkTo: item => {
            return `/orders/${item.order}`;
          }
        },
        {
          text: "תאריך יצירה",
          value: "created",
          align: "start",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            return data[key] ? this.heDate(data[key], false, true) : "לא ידוע";
          }
        },
        {
          text: "עריכה",
          type: "ACTION",
          value: "action",
          name: "storeTransfer",
          align: "start",
          visible: true,
          icon: "mdi-pencil",
          sortable: false,
          click: id => {
            let invoice = this.$store.state.entities.invoices[id];
            if (invoice) {
              this.editItem(invoice);
            }
            return Promise.resolve();
          }
        }
      ],
      filters: [
        {
          type: "BOOLEAN",
          label: "האם לא נשלח מייל",
          model: "notSentByEmail",
          active: true
        }
      ]
    };
  },
  computed: {
    resource() {
      return this.$store.state.resources["invoice"];
    },
    optionLists() {
      return {};
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    }
    // storeTransferDialog: {
    //   get() {
    //     return this.$store.state.storeTransferDialog;
    //   },
    //   set(isActive) {
    //     this.$store.commit("TOGGLE_STORE_TRANSFER_DIALOG", isActive);
    //   }
    // }
  },
  methods: {
    entityById(entityType, id) {
      return this.$store.getters["entity"](entityType, id);
    },
    editItem(item) {
      let resource = this.$store.state.resources.invoice;
      this.editEntity(item, resource);
    }
  },

  watch: {
    storeTransferDialog: {
      handler: function(val) {
        if (!val) {
          this.clickedImei = null;
        }
      }
    }
  },

  components: {
    AdvancedTable
  },
  mixins: [mixins]
};
</script>